// @ts-ignore
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

// import { Context } from 'data/context'

import { generateCompoundInterestData } from 'utils/vault'
import { StackedBarChart } from 'components/Charts/Victory'
import { mapInterestToStackedBar } from 'components/Charts/Victory/StackedBarChart/mapper'
import { IVaultCalculatorInput, VaultCalculator } from 'components/Calculators'

export const VaultPage = () => {
    // #region HOOKS
    const [searchParams] = useSearchParams();
    //#endregion

    //#region STATE
    const [loading, setLoading] = useState<boolean>(true);
    const [state, setState] = useState<IVaultCalculatorInput>({
        period: {
            value: 360,
            label: '12 months'
        },
        initialAmount: 0,
        monthlyAmount: 0
    })
    // #endregion
    // #region PARAMS
    const DEBUG = searchParams.get('DEBUG')
    const productCode = searchParams.get('productCode')
    const fromProduct = searchParams.get('fromProduct')
    const toProduct = searchParams.get('toProduct')
    const periodInDays = searchParams.get('periodInDays')
    const recurring = searchParams.get('recurring')
    const frequency = searchParams.get('frequency')
    //#endregion

    // #region HANDLERS
    const handleChange = (key: string) => (e: any) => {
        const value = e?.target?.value || e;

        console.log(`handleChange.${key}:`, value)

        if (['string', 'number'].includes(typeof value)) {
            setState((prevState: IVaultCalculatorInput) => ({
                ...prevState,
                [key]: value
            }))
        } else {
            if (key !== 'period')
                setState((prevState: IVaultCalculatorInput) => ({
                    ...prevState,
                    [key]: ''
                }))
        }
    }
    // #endregion

    //#region LIFECYCLE
    useEffect(() => {
        setLoading(false)
    }, [])
    //#endregion

    return (
        <div>
            <h1>Savings {productCode}</h1>

            {loading ? (
                <div className="loader" />
            ) : (
                (
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                        <VaultCalculator
                            value={state}
                            onChange={handleChange}
                        />
                        <div style={{ minWidth: '50rem' }}>
                            {
                                state?.initialAmount && state?.monthlyAmount && (
                                    <StackedBarChart series={
                                        mapInterestToStackedBar(
                                            generateCompoundInterestData({
                                                initialAmount: state.initialAmount as number,
                                                monthlyAmount: 0, //state.monthlyAmount as number,
                                                periodInDays: 360,
                                                interest: 0.0925
                                            })
                                        )}
                                    />
                                )}
                        </div>
                    </div>
                )
            )}



            {
                DEBUG && (
                    <ul style={{ width: 'fit-content', margin: 'auto', textAlign: 'left' }}>
                        <br />
                        <div>Params</div>
                        <li>productCode: {productCode}</li>
                        <li>fromProduct: {fromProduct}</li>
                        <li>toProduct: {toProduct}</li>
                        <li>periodInDays: {periodInDays}</li>
                        <li>recurring: {recurring}</li>
                        <li>frequency: {frequency}</li>
                        <br />
                        <div>State</div>
                        {/* <li>initialAmount: {state?.initialAmount}</li>
                        <li>monthlyAmount: {state?.monthlyAmount}</li> */}
                        {/* <li>period: {JSON.stringify(state?.period, null, 2)}</li> */}
                    </ul>
                )
            }
        </div>
    )
}